import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'white' | 'outline-light' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  children, 
  ...props 
}) => {
  // Added hover:-translate-y-1 for the lift effect
  const baseStyles = "inline-flex items-center justify-center font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent disabled:opacity-50 disabled:pointer-events-none rounded-2xl active:scale-[0.98] tracking-tight hover:-translate-y-1";
  
  const variants = {
    // Enhanced shadows for primary to match the lift
    primary: "bg-accent text-white hover:bg-accentHover shadow-lg shadow-accent/20 hover:shadow-2xl hover:shadow-accent/40 border border-transparent",
    // Added shadow to outline for depth on hover
    outline: "bg-transparent border-2 border-slate-200 text-slate-700 hover:border-accent hover:text-accent hover:shadow-lg hover:shadow-accent/10",
    // Enhanced shadows for white
    white: "bg-white text-slate-900 hover:bg-slate-50 shadow-soft hover:shadow-2xl hover:shadow-slate-200/50 border border-slate-100",
    // Added subtle shadow for light outline
    'outline-light': "border-2 border-white/20 text-white hover:bg-white/10 hover:border-white backdrop-blur-sm hover:shadow-lg hover:shadow-white/10",
    // Ghost remains minimal but gets the lift
    ghost: "bg-transparent text-slate-600 hover:text-accent hover:bg-accent/5"
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3.5 text-base",
    lg: "px-8 py-4 text-lg"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};